import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    // Check if element exists before initializing Swiper
    const swiperElement = document.querySelector('.about-slider .swiper');
    if (!swiperElement) {
        return;
    }
    
    const aboutSwiper = new Swiper('.about-slider .swiper', {
        modules: [Navigation, Pagination],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        loop: false,
        watchOverflow: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        allowTouchMove: true,
        breakpoints: {
           
            1024: {
                slidesPerView: '1.25',
                centeredSlides: true,
                spaceBetween: 40,
            },
            1440: {
                slidesPerView: '1.75',
                centeredSlides: true,
                spaceBetween: 50,
            }

        },
        pagination: {
            el: '.about-slider .swiper-pagination--about',
            clickable: true,
        },
        navigation: {
            nextEl: '.about-slider .swiper-button-next--about',
            prevEl: '.about-slider .swiper-button-prev--about',
            disabledClass: 'swiper-button-about-disabled',
        },
        
        on: {
            init: function() {
                this.update();
                if (this.navigation) {
                    this.navigation.update();
                }
                setTimeout(() => {
                    updateButtonStates();
                    updateSlideCounter();
                }, 100);
            },
            slideChange: function() {
                updateButtonStates();
                updateSlideCounter();
            }
        }
    });
    
    // Function to manage button disabled states
    function updateButtonStates() {
        const prevButton = document.querySelector('.about-slider .swiper-button-prev--about');
        const nextButton = document.querySelector('.about-slider .swiper-button-next--about');
        
        if (!aboutSwiper) return;
        
        if (prevButton) {
            if (aboutSwiper.activeIndex === 0) {
                prevButton.classList.add('swiper-button-about-disabled');
            } else {
                prevButton.classList.remove('swiper-button-about-disabled');
            }
        }
        
        if (nextButton) {
            // Bij 1.5 slides per view kunnen we nog naar de volgende slide als er meer dan 1 slide is
            if (aboutSwiper.activeIndex >= aboutSwiper.slides.length - 1) {
                nextButton.classList.add('swiper-button-about-disabled');
            } else {
                nextButton.classList.remove('swiper-button-about-disabled');
            }
        }
    }

    // Slide counter (1-based, met leading zero)
    function updateSlideCounter() {
        const slideCounter = document.querySelector('.about-slider .--current-slide');
        if (slideCounter && aboutSwiper) {
            const counterValue = (aboutSwiper.activeIndex + 1).toString().padStart(2, '0');
            slideCounter.textContent = counterValue;
        }
    }
});
